import { render } from "./BlViewPhone.vue?vue&type=template&id=df4ec8ee&scoped=true"
import script from "./BlViewPhone.vue?vue&type=script&lang=js"
export * from "./BlViewPhone.vue?vue&type=script&lang=js"

import "./BlViewPhone.vue?vue&type=style&index=0&id=df4ec8ee&scoped=true&lang=scss"

import exportComponent from "/tmp/5ea1362f-94e3-43d0-86d7-afc144980eef/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df4ec8ee"]])

export default __exports__